// extracted by mini-css-extract-plugin
export default {"container":"EdLe9T"};